<template>
  <div
    class="o-alert u-padding-bottom-xlarge-xs-down u-padding-bottom o-alert--warning u-margin-0 u-padding-xsmall"
  >
    <i class="icofont-warning"></i> {{ $t("batteryDetail.isOldLogBar") }}
    <Button
      class="u-float-right u-margin-top-xsmall"
      variant="warning"
      :disabled="battery.isLocked"
      @click="showModal = true"
      size="sm"
    >
      <i class="icofont-ui-lock" v-if="battery.isLocked"></i>
      {{ $t("common.reactivate") }}
    </Button>
    <UpdateModal
      v-model="showModal"
      @ok="REACTIVE_BATTERY"
      :description="$t('batteryDetail.isOldLogBarReactiveDescription')"
    ></UpdateModal>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Button from "../Base/Button.vue";
import UpdateModal from "@/components/Shared/UpdateModal/index.vue";
export default {
  components: {
    Button,
    UpdateModal,
  },
  data() {
    return {
      showModal: false,
    };
  },
  props: {
    battery: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async REACTIVE_BATTERY(loading) {
      loading(true);
      const response = await Requests.Battery.ReactivateBattery({
        id: this.battery.id,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateBatteries.success`),
          variant: "success",
          duration: 2500,
        });
        setTimeout(() => {
          location.reload();
        }, 2500);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
  },
};
</script>

<style></style>
